import React from 'react';
import { SearchByResult } from '../redux/api-slice';
import { useAppSelector } from '../redux/hooks'

export default function ResultFiltered(result: SearchByResult) {
    const linkLabel = useAppSelector((state) => state.pageSettings.linkLabel);
    return (
        <li className="performance-search-result" key={result.operaId} >
            <p className="performance-search-result-composer"> {result.composerName}</p>
            <div className="performance-search-result-content">
                <div className="performance-search-result-title">
                    <h3 className="h4-style"> {result.operaTitle} </h3>
                    <div className="performance-search-result-filtered">
                        {
                            result.castResults?.map(cast => (
                                <div className="performance-search-result-filtered-item">
                                    <p><strong>{cast.season}</strong></p>
                                    <div>
                                        <span>{cast.roleTitle} -</span> <span> {cast.artistFullName}</span>
                                        {
                                            cast.debut && <><span aria-hidden="true"> *</span><span className="visually-hidden">artist's Lyric debut</span></>
                                        }
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
                <div className="performance-search-result-link">
                    <a className="btn" href={result.detailPageUrl}>{linkLabel}</a>
                </div>
            </div>
        </li>
    );
}
